import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { LanguageService } from './language.service';
import { Citizen } from '../models/classes/citizen/citizen';
import { UiService } from './ui.service';

@Injectable({
    providedIn: 'root'
})
export class CitizenService {
    citizenChanged = new Subject<Citizen>();

    private baseUrl = environment.apiUrl + 'citizens';

    constructor(
        private http: HttpClient,
        private languageSrv: LanguageService,
        private uiSrv: UiService
    ) { }

    get(organismCode: string): Observable<Citizen> {
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.http.get<Citizen>(`${this.baseUrl}/${this.languageSrv.getCurrentLanguageCode()}/${organismCode}`)
        .pipe(
            tap(citizen => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                this.citizenChanged.next({ ...citizen });
            })
        );
    }
}
